import MetaTags from 'components/MetaTags'
import { defaultMeta } from 'shared/constants'
import Blog from 'components/Blog'

const BlogPage = () => (
  <>
    <MetaTags data={defaultMeta} />
    <Blog />
  </>
)

export default BlogPage
